import React, { memo } from 'react'
import styled from '@emotion/styled'
import { useTranslation } from 'react-i18next'
import { ReactComponent as TableViewIcon } from '../../../../assets/icons/app/table-view.icon.svg'
import { useAppSelector } from '../../../../store/hooks'
import {
  selectAnalyticDetailsStateAnalyticDetails,
  selectAnalyticDetailsStateAnalyticDetailsAuthorsInput,
  selectAnalyticDetailsStateAnalyticDetailsAuthorsOutput,
  selectAnalyticDetailsStateIsLoadingGetAuthorRecoV3,
  selectAnalyticDetailsStateIsLoadingGetAuthorRecoV3Add,
  selectAnalyticDetailsStateIsLoadingGetAuthorRecoV3Remove,
  selectAnalyticDetailsStateIsLoadingNewConstellationGetAuthorReco,
  selectAnalyticDetailsStateIsLoadingPostNewAnalytic,
  selectAnalyticDetailsStateIsLoadingPutAnalytic,
  selectAnalyticDetailsStateNeedSaveAnalyticDetails,
} from '../../../../store/getters/analytics-details/analytic-details-v2.getters'
import GlLoader from '../../../share/GlLoader'
import D3ConstellationAuthorMirror from './constellation/D3ConstellationAuthorMirror'
import { AuthorMirrorAuthorInterface } from '../../../../core/interface/report/author-mirror-author.interface'
import AnalyticDetailsAuthorsInput from './AnalyticDetailsAuthorsInput'

const CardLayoutStyle = styled.div`
  z-index: 0;
  background: rgba(255, 255, 255, 0.01);
`

const AuthorMirrorConstellationCard = ({
  openListCard,
  handleOpenListView,
  handleSaveAnalytics,
  handleShareAnalytics,
  handleAuthorHovered,
  authorDetailsSelected,
  handleAuthorSelected,
}: {
  openListCard: boolean
  handleOpenListView: () => void
  handleSaveAnalytics: () => void
  handleShareAnalytics: () => void
  handleAuthorHovered: (authorId: string | null) => void
  authorDetailsSelected: AuthorMirrorAuthorInterface | null
  handleAuthorSelected: (
    authorDetails: AuthorMirrorAuthorInterface | null,
  ) => void
}) => {
  const { t } = useTranslation()
  const handleOnClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
    handleOpenListView()
  }

  const analyticsDetails = useAppSelector(
    selectAnalyticDetailsStateAnalyticDetails,
  )
  const isLoadingGetAuthorRecoV3 = useAppSelector(
    selectAnalyticDetailsStateIsLoadingGetAuthorRecoV3,
  )

  const isLoadingNewConstellationGetAuthorReco = useAppSelector(
    selectAnalyticDetailsStateIsLoadingNewConstellationGetAuthorReco,
  )

  const isLoadingGetAuthorRecoV3Add = useAppSelector(
    selectAnalyticDetailsStateIsLoadingGetAuthorRecoV3Add,
  )

  const isLoadingGetAuthorRecoV3Remove = useAppSelector(
    selectAnalyticDetailsStateIsLoadingGetAuthorRecoV3Remove,
  )

  const authorsInput = useAppSelector(
    selectAnalyticDetailsStateAnalyticDetailsAuthorsInput,
  )

  const authorsOutput = useAppSelector(
    selectAnalyticDetailsStateAnalyticDetailsAuthorsOutput,
  )

  const isLoadingPostNewAnalytic = useAppSelector(
    selectAnalyticDetailsStateIsLoadingPostNewAnalytic,
  )
  const isLoadingPutAnalytic = useAppSelector(
    selectAnalyticDetailsStateIsLoadingPutAnalytic,
  )

  const needSaveAnalyticDetails = useAppSelector(
    selectAnalyticDetailsStateNeedSaveAnalyticDetails,
  )

  return (
    <CardLayoutStyle className="relative flex-auto flex flex-col rounded-xl shadow-lg bg-white basis-2/3">
      <div className="flex items-start justify-between m-2">
        <AnalyticDetailsAuthorsInput
          permission={analyticsDetails?.permission}
          needSave={needSaveAnalyticDetails}
          canShare={!!analyticsDetails?.id}
          handleSaveAnalytics={handleSaveAnalytics}
          handleShareAnalytics={handleShareAnalytics}
          analyticsType={analyticsDetails.type}
        />
        {(!openListCard && (
          <button
            type="button"
            className="flex flex-row gap-2 rounded p-2 items-center justify-center hover:shadow-xl bg-black text-white"
            onClick={handleOnClick}
            style={{
              zIndex: 10,
            }}
          >
            <TableViewIcon />
            <span>{t('commons.buttons.list')}</span>
          </button>
        )) ||
          null}
      </div>
      {((isLoadingGetAuthorRecoV3 ||
        isLoadingNewConstellationGetAuthorReco ||
        isLoadingGetAuthorRecoV3Add ||
        isLoadingGetAuthorRecoV3Remove ||
        isLoadingPostNewAnalytic ||
        isLoadingPutAnalytic) && (
        <div
          className="absolute top-0 left-0 w-full h-full flex items-center justify-center"
          style={{
            zIndex: 2,
          }}
        >
          <GlLoader />
        </div>
      )) || (
        <D3ConstellationAuthorMirror
          authorsInput={authorsInput}
          authorsOutput={authorsOutput}
          handleAuthorHovered={handleAuthorHovered}
          authorDetailsSelected={authorDetailsSelected}
          handleAuthorSelected={handleAuthorSelected}
        />
      )}
    </CardLayoutStyle>
  )
}

export default memo(AuthorMirrorConstellationCard)
